// extracted by mini-css-extract-plugin
export default {"page":"SV-z","cartModal":"TV-z","checkout":"UV-z","placeholder":"VV-z","account":"WV-z"};